import { designSystemColors } from '@klv/shared/styles/colors';

import type { ISubcategoryCardTheme } from '../../types';

const subcategoryCard: ISubcategoryCardTheme = {
  default: {
    background: designSystemColors.white,
    border: designSystemColors.poppy,
    color: designSystemColors.charcoal,
  },
  hover: {
    background: designSystemColors.white,
    border: designSystemColors.poppy,
    color: designSystemColors.charcoal,
  },
};

export default subcategoryCard;
